<script setup lang="ts">

import { onMounted, ref } from "vue";
import { useViewModelInstance } from "@app/MyGarage";
import { useBackButton } from "@app/Components/Utilities";
import ServiceLogPanel from "./Components/ServiceLogPanel.vue";
import BookingPanel from "@app/MyGarage/Views/DigitalServiceLog/Components/BookingPanel.vue";
import type { IAppointment } from "@domain/Appointment/IAppointment";
import { DealerLocation } from "@app/Components/DealerLocation";

const model = await useViewModelInstance();
const openBookings = model.appointments.filter( appointment => appointment.isOpen ) as IAppointment[];
const isExpanded = ref( false );

onMounted( () =>
{
    useBackButton();
} );

</script>

<template>
    <div class="bg-gray-50/70 dark:bg-gray-900 text-gray-800 dark:text-white
                text-base lg:text-lg
                w-full h-full overflow-y-auto overflow-x-hidden flex flex-col pb-12">

        <div class="bg-gradient-to-b dark:from-gray-900 dark:to-gray-850">

            <div class="p-6 text-center">
                <h2 class="text-xl 3xl:text-2xl tracking-wider flex gap-2 justify-center items-center">
                          Digital Service Log
                </h2>
                <p class="text-sm lg:text-base 3xl:text-xl pt-4 3xl:pt-6 opacity-60">
                    Your digital service log is an approved
                    record of your vehicle's service history
                </p>

                <div v-if="isExpanded == false"
                     class="flex justify-center pt-4 text-base">
                    <Button variant="text"
                            color="secondary"
                            @click="() => isExpanded = true">
                         Contact Service Center
                    </Button>
                </div>
                    
            </div>   

        </div>

        <div v-show="isExpanded"
             class="flex flex-col px-4 lg:px-6 gap-4 lg:gap-6 3xl:gap-8
                    bg-gradient-to-b dark:from-gray-850 dark:to-gray-900">
            <DealerLocation title="Service Center" type="service" />
        </div>

        <BookingPanel :open-bookings="openBookings" />
        <Spacer v-if="openBookings.length > 0" />

        <!-- SERVICE HISTORY -->
        <ServiceLogPanel v-model="model" />

    </div>

</template>
